import styled from 'styled-components';

export const BenifitList = styled.ul`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 4rem;
    margin: ${p => p.margin ? p.margin : ''};

    >li{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        flex-shrink: 0;
        .iconCont{
            height: 5rem;
            margin-bottom: 1rem;
        }
        >p{
            font-size: 1.4 rem;
            max-width: 10rem;
            color: #000000;
            flex: 1;
            margin-bottom: 1.5rem;
            font-style: normal;
        }
        .benifitTag{
            display: flex;
            align-items: center;
            padding: 0.3rem 1.4rem;
            border-radius: 1rem;
            background-image: linear-gradient(80deg, #00c57e, #18a160 100%);
            font-size: 1.2rem;
            font-weight: 600;
            color: #fff;
            flex-shrink: 0;
        }
    }
    .viewAll{
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        text-align: center;
        .viewAll__count{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 4.2rem;
            height: 4.2rem;
            border-radius: 0.4rem;
            background-color: #d1e5ff;
            margin-bottom: 1.5rem;
            font-size: 1.6rem;
            font-weight: 600;
            color: #2276e3;
        }
        .viewAllText{
            font-size: 1.2rem;
            line-height: 1.6rem;
            color: #2276e3;
            max-width: 6rem;
        }
    }
`;